import { SegmentPage } from '@enums/segment'
import { checkSegmentId } from '@util/check-segment-id'

// contract expected by Data Science
type SegmentPageEvent = {
  (pageName: SegmentPage): void
}

export const pageEvent: SegmentPageEvent = (name) => {
  const analytics = window.analytics
  analytics?.ready(() => {
    checkSegmentId()
    analytics.page(name)
  })
}
